import React, { useEffect, useRef, useState } from 'react'
import req from '@sportninja/common/api/request'

import LoadingSpinner from '../../components/LoadingSpinner'

const BambuserPlayer = ({ game, isPublicRoute }) => {
  const [ loading, setLoading ] = useState(false)
  const [ resourceUri, setResourceUri ] = useState('')
  const lastFailedBroadcastId = useRef(null)
  const interval = useRef(null)

  const get = async () => {
    setLoading(true)
    const { data } = await req(`${isPublicRoute ? '/public' : ''}/games/${game.id}/shallow`)

    if (!data || !data.broadcast_id || data.broadcast_id === lastFailedBroadcastId.current) {
      setLoading(false)
      return
    }

    try {
      const response = await fetch(`https://api.bambuser.com/broadcasts/${data.broadcast_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/vnd.bambuser.v1+json',
          Authorization: `Bearer ${process.env.REACT_APP_BAMBUSER_WEB_API_KEY}`
        }
      })

      // If its a status error, then dont try requesting from bambuser again for awhile
      if (response?.status > 299) {
        // However, if it's another type of network error, set a longer interval and try again
        throw new Error(`Network error: ${response?.status}`)
      }

      const broadcast = await response.json()

      if (!broadcast) {
        lastFailedBroadcastId.current = data.broadcast_id
        return
      }

      const resourceUri = broadcast.resourceUri
      clearInterval(interval.current)
      setResourceUri(resourceUri)
    // eslint-disable-next-line no-empty
    } catch(e) {}

    setLoading(false)
  }

  useEffect(() => {
    get()
    interval.current = setInterval(get, 20000)

    return () => {
      clearInterval(interval.current)
    }
  }, [ game.id ])

  if (loading) {
    return (
      <LoadingSpinner />
    )
  }
  if (!resourceUri) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        No broadcasts available
      </div>
    )
  }

  return (
    <div style={{ width: '100%', paddingBottom: '56.25%', position: 'relative', display: 'flex', justifyContent: 'center', marginBottom: 40 }}>
      <iframe
        style={{ position: 'absolute', width: '90%', height: '100%', border: 'none' }}
        src={`https://cdn.bambuser.net/player/?resourceUri=${encodeURIComponent(resourceUri)}`}
        allowFullScreen></iframe>
    </div>
  )
}

export default BambuserPlayer
